var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRussia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_192_3112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9625 0.75C7.08745 0.75 2.92495 3.9 1.38745 8.25H22.6124C21.0374 3.9 16.8749 0.75 11.9625 0.75Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9625 23.25C16.875 23.25 21.0375 20.1 22.575 15.75H1.38745C2.92495 20.1375 7.08745 23.25 11.9625 23.25Z",
    fill: "#CE2028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3875 8.25C0.975 9.4125 0.75 10.6875 0.75 12C0.75 13.3125 0.975 14.5875 1.3875 15.75H22.6125C23.025 14.5875 23.25 13.3125 23.25 12C23.25 10.6875 23.025 9.4125 22.6125 8.25H1.3875Z",
    fill: "#22408C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_192_3112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRussia);
export default __webpack_public_path__ + "static/media/russia.54e55be822e0b37c6373cc25e6ae631f.svg";
export { ForwardRef as ReactComponent };